import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function Products() {
  const [loading, setLoading] = useState(true);

  
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); 
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <style>{`

      
        /* Loader styles */
        .loader {
          width: 48px;
          height: 48px;
          margin: 100px auto;
          position: relative;
        }

        .loader:before {
          content: '';
          width: 48px;
          height: 5px;
          background: #999;
          position: absolute;
          top: 60px;
          left: 0;
          border-radius: 50%;
          animation: shadow324 0.5s linear infinite;
        }

        .loader:after {
          content: '';
          width: 100%;
          height: 100%;
          background: rgb(61, 106, 255);
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 4px;
          animation: jump7456 0.5s linear infinite;
        }

        @keyframes jump7456 {
          15% { border-bottom-right-radius: 3px; }
          25% { transform: translateY(9px) rotate(22.5deg); }
          50% { transform: translateY(18px) scale(1, .9) rotate(45deg); border-bottom-right-radius: 40px; }
          75% { transform: translateY(9px) rotate(67.5deg); }
          100% { transform: translateY(0) rotate(90deg); }
        }

        @keyframes shadow324 {
          0%, 100% { transform: scale(1, 1); }
          50% { transform: scale(1.2, 1); }
        }

        .product-container {
          width: 100%;
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-wrap: wrap;
          background-color: #f0f0f0;
          padding: 20px;
          gap: 20px;
          box-sizing: border-box;
        }

        .product {
          width: 22%;
          height: 330px;
          border: 3px solid black;
          border-radius: 13px;
          background-color: white;
          overflow: hidden;
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          animation: slideUpFade 0.6s ease-in-out;
        }

        .product:hover {
          transform: scale(1.03);
          box-shadow: 0 10px 16px rgba(0, 0, 0, 0.2);
        }

        .product img {
          width: 100%;
          height: 200px;
          object-fit: contain;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }

        .product p {
          padding: 10px;
          text-align: center;
          font-size: 1.1rem;
          margin: 0;
          height: 80px;
        }

        .product button {
          width: 100%;
          padding: 10.23px;
          background-color: #007bff;
          color: white;
          border: none;
          border-radius: 0 0 10px 10px;
          cursor: pointer;
          font-size: 1rem;
        }

        @media (max-width: 768px) {
          .product { width: 45%; }
        }

        @media (max-width: 480px) {
          .product { width: 100%; }
        }

        @keyframes slideUpFade {
          0% { transform: translateY(30px); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }
      `}</style>

      {loading ? (
        <div className="loader" />
      ) : (
        <div className="product-container">
        <div className="product">
          <img src="image.png" alt="product1" style={{ objectFit: "fill" }}/>
          <p>Hospital Cubical Curtains</p>
          <Link to="/hospitalCubicalCurtains">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img src="bhp.png" alt="product1" />
          <p>Bed Head Panel</p>
           <Link to="/bedHeadPanel">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img src="gt.png" alt="product1" />
          <p>Gas Outlet Point(PB Compatible)</p>
           <Link to="/gas-Outlet-Point">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img src="gt1.png" alt="product1" />
          <p>Gas Outlet (British Standard)</p>
           <Link to="/gas-Outlet">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img
            src="wvu.png"
            alt="product1"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "contain",
            }}
          />
          <p>Ward Vaccum Unit</p>
           <Link to="/ward-vacuum-unit">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img src="tst.png" alt="product1" />
          <p>Theatre Suction Trolley</p>
           <Link to="/theatre-suction-trolley">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img src="ofm.png" alt="product1" />
          <p>Oxygen Flow Meter</p>
           <Link to="/oxygen-flow-meter">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img src="fm.png" alt="product1" 
          style={{
            objectFit: "fill",
      
          }}
          />

          <p>Flow Meter</p>
           <Link to="/flow-meter">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img src="avb.png" alt="product1" style={{ objectFit: "fill", clipPath: "inset(0 0 0 2px)" }}/>
          <p>Area Valve Box</p>
           <Link to="/area-valve-box">
            <button>View Details</button>
          </Link>
        </div>
         <div className="product">
          <img src="aa.png" alt="product1" style={{ objectFit: "fill" }} />
          <p>Area Alarm (Analog)</p>
           <Link to="/area-alarm-analog">
            <button>View Details</button>
          </Link>
        </div>
         <div className="product">
          <img src="aad.png" alt="product1" style={{ objectFit: "fill" }}/>
          <p>Area Alarm (Digital)</p>
           <Link to="/area-alarm-digital">
            <button>View Details</button>
          </Link>
        </div>
        

      </div>
      )}
    </>
  );
}


export default Products;
